import PropTypes from "prop-types"
import React, { Component } from "react"
import { BlockContextConsumer } from "../ContextProviders"

class BroadcastItem extends Component {
    static propTypes = {
        name: PropTypes.string,
        id: PropTypes.string,
        deep: PropTypes.bool,
    }
    renderChildren(value) {
        if (!value) return null
        return this.props.children(value)
    }
    render() {
        if (!this.props.name && !this.props.id) {
            return null
        }

        return (
            <BlockContextConsumer>
                {({ broadcast }) =>
                    this.props.name
                        ? this.renderChildren(
                              broadcast.getItemByName(this.props.name, this.props.deep)
                          )
                        : this.renderChildren(broadcast.getItemById(this.props.id, this.props.deep))
                }
            </BlockContextConsumer>
        )
    }
}

export default BroadcastItem



// WEBPACK FOOTER //
// ./src/features/editor/broadcast/BroadcastItem.js